angular.module('app.controllers').controller 'ApplicationCtrl', [
  '$scope', '$route', '$rootScope', 'APIFavorites', '$sce', 'APIInteractions', '$interval', '$cookies', 'UI', '$location', 'APIRead', 'APIExhibitors', 'APIStatistics', '$timeout', 'detectUtils', 'deviceDetector', 'APIData', '$window'
].append (self, $route, root, APIFavorites, $sce, APIInteractions, $interval, $cookies, UI, $location, APIRead, APIExhibitors, APIStatistics, $timeout, detectUtils, deviceDetector, APIData, $window) ->
  
  params = $location.search()

  self.trustAsResourceUrl = $sce.trustAsResourceUrl
  
  self.trustAsHtml = (string) -> return $sce.trustAsHtml(string)
  
  self.counter =
    favs: 0
  
  #
  # Favorites list
  #

  self.favorites = []
  self.getFavorites = () ->        
    APIFavorites.query {shortcode: root.shortcode || 'test'}, (data) ->
      self.favorites = data

  # get favorites when session load and we have user shortcode
  self.$on 'getFavorites', (event) ->
    self.getFavorites()

  self.$emit 'getFavorites'

  self.toggleFavs = (entrycode, entry, shortcode = false) ->   
    return if self.at('share')
    # request params
    shortcode     = root.shortcode || 'test' unless shortcode
    entrydata     = angular.copy(entry)
    exhibitor_id  = entrydata.exhibitor_id || entrydata.id
    exhibitor_id  = entrydata.exhibitor_id if entrydata.exhibitor_id == 0

    entry_id = ''
    entry_id = entrydata.entry_id if entrydata.entry_id || entrydata.entry_id == 0
          
    data = entrydata
    data = {} if entrycode in ['ex', 'ph', 'jo', 'tt'] # no need save data for some entries because they saved in database
      
    fav_code  = "#{entrycode}#{exhibitor_id}#{entry_id}"
    fav_codes = self.favorites.map((item) -> return item.fav_code)       
    fav_index = fav_codes.indexOf(fav_code)

    # remove from favorites
    if fav_index != -1
      
      return if entrycode is 'sc'

      (new APIFavorites).$delete {shortcode: shortcode, entrycode: entrycode, exhibitor_id: exhibitor_id, entry_id: entry_id}, () ->
        self.favorites.splice(fav_index, 1)
        self.$emit('forceFavs', if entrycode == 'pr' then 'ph' else entrycode) if self.at('favs')
      , (errorData) -> console.debug errorData.data.error

    # save as favorites
    else

      (new APIFavorites data).$save {shortcode: shortcode, entrycode: entrycode, exhibitor_id: exhibitor_id, entry_id: entry_id}, () ->

        # track events
        if entrycode == 'ex' # exhibitors
          self.customStat(exhibitor_id, 'exhibitor_save', entrydata.exhibitor_name)

        # track events
        if entrycode == 'sc'
          self.customStat(exhibitor_id, 'exhibitor_scan', entrydata.exhibitor_name)

        if entrycode == 'do' # download
          self.customStat(exhibitor_id, 'download_save', entrydata.title)

        if entrycode == 'jo' # jobs
          self.customStat(exhibitor_id, 'job_save', entrydata.title)

        if entrycode == 'pr' # program
          self.customStat(null, 'program_save', entrydata.title_de || entrydata.title)

        if entrycode == 'ph' # program_highlights
          self.customStat(exhibitor_id, 'program_save', entrydata.title)

        if entrycode == 'tt' # talent tube
          self.customStat(exhibitor_id, 'video_save', entrydata.title)

        entrydata.fav_code = fav_code
        self.favorites.push entrydata
      , (response) -> 
        UI.notify false, response.data.error

    return

  self.isFavs = (entrycode, exhibitor_id = null, entry_id = '') -> 
    #return false unless self.ha() # always return false for GUEST user
    return false unless exhibitor_id?
    fav_code = "#{entrycode}#{exhibitor_id}#{entry_id}"
    fav_codes = self.favorites.map((item) -> return item.fav_code)
    return fav_code in fav_codes

  self.$watch 'favorites', (newObj, oldObj) -> 
    return unless newObj
    
    favs = angular.copy(newObj)
    #return if favs?.length == 0

    counter1 = ['ex', 'do', 'jo', 'pr', 'ph', 'tt']
    c1 = favs.filter (item) -> return item.fav_code.substr(0,2) in counter1
    self.counter.favs = c1.length

  , true

  #
  # Track events
  #

  self.customStat = (exhibitor_id = null, method, description = '') ->

    data =
      method: method
      description: description
    
    data.exhibitor_id = exhibitor_id if exhibitor_id?

    (new APIStatistics data).$save {}, (response) ->
      return
    , (response) ->
      UI.notify false, response.data.error

  #
  # Data modal
  #

  self.videoModalEl = document.getElementById('videoModal')
  
  if self.videoModalEl
    self.videoModal = bootstrap.Modal.getOrCreateInstance(self.videoModalEl)

    self.videoModalEl.addEventListener('hide.bs.modal', (event) ->
      self.closeDataModal()
      self.$applyAsync()
    )

  self.modalData = null
  self.videomp4 = false
  self.showDataModal = (source, exhibitor_id = null, mp4 = false) ->
    self.videomp4 = mp4
    if source.embed
      #self.customStat(exhibitor_id, 'video_open', source.title) if exhibitor_id?
      self.$emit 'showDataModal', {video: source.embed}
    else
      self.$emit 'showDataModal', source  

  self.closeDataModal = () ->
    self.$emit 'closeDataModal'

  self.$on 'showDataModal', (event, source) ->
    self.modalData = source

  self.$on 'closeDataModal', (event) ->
    self.modalData = null
    self.videomp4 = false
    self.$applyAsync()

  #
  # Slider settings
  #

  self.imageSlider =
    dots: true
    dotsClass: 'slider-dots'
    customPaging : (slider, i) -> 
      return false if slider.slideCount == 1 || slider.slideCount == slider.options.slidesToShow
      return "<a class='slider-dots-item'></a>"

    slidesToShow: 1
    slidesToScroll: 1
    prevArrow: '<div class="slider-control slider-control-prev"></div>'
    nextArrow: '<div class="slider-control slider-control-next"></div>'
    speed: 500
    fade: true
    autoplay: true
    autoplaySpeed: 5000
    useCSS: false
    cssEase: 'linear'


  self.openContact = (exhibitor_id, email) ->
    self.customStat(exhibitor_id, 'contact_open')
    root.$broadcast 'openContactModal', email, exhibitor_id

  

  self.onVimeoIframeAPIReady = (video_id = null, exhibitor_id = null, video_title = '', autoplay = false) ->
    return unless video_id

    options =
      id: video_id
      loop: true

    player = new Vimeo.Player('ytPlayer', options)
    player.setVolume(0)

    player.on('play', (data) ->
      self.customStat(exhibitor_id, 'video_open', video_title)
    )

    player.play() if autoplay


  self.onYouTubeIframeAPIReady = (video_id = null, exhibitor_id = null, video_title = '', autoplay = false) ->
    return unless video_id

    player = new YT.Player('ytPlayer', {
      videoId: video_id
      playerVars:
        enablejsapi: 1
        showinfo: 0
        controls: 2
        autoplay: if autoplay then 1 else 0
        origin: 'https://digi.jugendundberuf.info'
      events: 
        'onStateChange': (event) ->
          if (event.data == YT.PlayerState.PLAYING)
            self.customStat(exhibitor_id, 'video_open', video_title)
            playing = true   
          else if (event.data == YT.PlayerState.PAUSED)
            playing = false
    })

